import { inject, Service } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { DienstleistungService } from '../../dienstleistung/dienstleistung.service';

@Service()
export class AttributGruppeResolver {
  private service = inject(DienstleistungService);

  resolve(route: ActivatedRouteSnapshot): string {
    const gruppe: string = route.params['gruppe'];

    if (gruppe) {
      this.service.updateHauptGruppe(gruppe);
    }
    return gruppe;
  }
}
